<template>
<div class="chapter">
<div class="inner_page">
<h1 class="cn"><strong>CONTENTS</strong></h1>
<p class="tocfms"><a href="#/OEBPS/pro.htm">Prologue: How Camest Thou in This Pickle?</a></p>
<p class="tocc"><a href="#/OEBPS/c01.htm"><strong>Chapter One:</strong> <br/>Hang Not on My Garments</a></p>
<p class="tocc"><a href="#/OEBPS/c02.htm"><strong>Chapter Two:</strong> <br/>O Brave New World</a></p>
<p class="tocc"><a href="#/OEBPS/c03.htm"><strong>Chapter Three:</strong> <br/>What a Spendthrift Is He of His Tongue</a></p>
<p class="tocc"><a href="#/OEBPS/c04.htm"><strong>Chapter Four:</strong> <br/>Good Wombs Have Borne Bad Sons</a></p>
<p class="tocc"><a href="#/OEBPS/c05.htm"><strong>Chapter Five:</strong> <br/>Now My Charms Are All O’erthrown</a></p>
<p class="tocc"><a href="#/OEBPS/c06.htm"><strong>Chapter Six:</strong> <br/>These Are Not Natural Events</a></p>
<p class="tocc"><a href="#/OEBPS/c07.htm"><strong>Chapter Seven:</strong> <br/>Come, Temperate Nymphs, and Help to Celebrate</a></p>
<p class="tocc"><a href="#/OEBPS/c08.htm"><strong>Chapter Eight:</strong> <br/>All Men Idle, All. And Women Too</a></p>
<p class="tocc"><a href="#/OEBPS/c09.htm"><strong>Chapter Nine:</strong> <br/>Make Yourself Ready … For the Mischance of the Hour</a></p>
<p class="tocc"><a href="#/OEBPS/c10.htm"><strong>Chapter Ten:</strong> <br/>They’ll Take Suggestion as a Cat Laps Milk</a></p>
<p class="tocc"><a href="#/OEBPS/c11.htm"><strong>Chapter Eleven:</strong> <br/>Now I Will Believe That There Are Unicorns</a></p>
<p class="tocc"><a href="#/OEBPS/c12.htm"><strong>Chapter Twelve:</strong> <br/>The Rarer Action Is in Virtue Than in Vengeance</a></p>
<p class="tocc"><a href="#/OEBPS/c13.htm"><strong>Chapter Thirteen:</strong> <br/>Unless I Be Reliev’d by Prayer</a></p>
<p class="tocc"><a href="#/OEBPS/c14.htm"><strong>Chapter Fourteen:</strong> <br/>A Thousand Twangling Instruments Will Hum about Mine Ears</a></p>
<p class="tocc"><a href="#/OEBPS/c15.htm"><strong>Chapter Fifteen:</strong> <br/>You Cram These Words Into Mine Ears Against the Stomach of My Sense</a></p>
<p class="tocc"><a href="#/OEBPS/c16.htm"><strong>Chapter Sixteen:</strong> <br/>Sweet Lord, You Play Me False</a></p>
<p class="tocc"><a href="#/OEBPS/c17.htm"><strong>Chapter Seventeen:</strong> <br/>Untie the Spell</a></p>
<p class="tocc"><a href="#/OEBPS/c18.htm"><strong>Chapter Eighteen:</strong> <br/>’Tis a Villain, Sir, I Do Not Love to Look On</a></p>
<p class="tocc"><a href="#/OEBPS/c19.htm"><strong>Chapter Nineteen</strong>:<br/>
Hark! Now I Hear Them — Ding-Dong, Bell</a></p>
<p class="tocc"><a href="#/OEBPS/c20.htm"><strong>Chapter Twenty:</strong> <br/>We Are Such Stuff as Dreams Are Made On</a></p>
<p class="tocsfm"><a href="#/OEBPS/cop.htm">Copyright</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?92ab591c